import {
  BaseWidget,
  BaseWidgetProps,
  Config,
  FactoryWithContext,
} from '@react-awesome-query-builder/mui';

import { AutocompleteResult, TemplatePlaceholder } from '@/types';
import { Box } from '@mui/material';
import EngagementForm from '@pages/QuickFilterListCreatorPage/criteriaComponents/EngagementForm';
import { MappingError } from '@/pages/AdvancedSearchListCreatorPage/qbRulePropertiesMapping/FilterMappers';
import { TemplatableActivityDateRange } from '@/apis/activityDateRange';

import { useAdvancedSearchDateFilterInvalid } from './useAdvancedSearchDateFilterInvalid';

export type EngagementHistoryWidgetValue = {
  activity: AutocompleteResult[] | TemplatePlaceholder;
  activityStatus: AutocompleteResult[] | TemplatePlaceholder;
  activityDateRange: TemplatableActivityDateRange;
  subject: string | TemplatePlaceholder;
  errors: MappingError[];
};

type CombinedProps = BaseWidgetProps<Config, EngagementHistoryWidgetValue>;

const defaultFilterValue: EngagementHistoryWidgetValue = {
  activity: [],
  activityStatus: [],
  activityDateRange: {
    displayedStartDate: null,
    displayedEndDate: null,
    periodValue: 'bytimeperiod',
    periodDetails: 'lastweek',
  },
  errors: [],
  subject: '',
};

const EngagementHistoryWidgetFactory: FactoryWithContext<CombinedProps> = ({
  value,
  setValue,
}: CombinedProps) => {
  const setIsFilterInvalid = useAdvancedSearchDateFilterInvalid();
  const handleChangeActivity = (newValue: AutocompleteResult[] | TemplatePlaceholder) => {
    setValue({
      ...(value ?? defaultFilterValue),
      activity: newValue,
      errors: [],
    });
  };

  const handleChangeActivityStatus = (newValue: AutocompleteResult[] | TemplatePlaceholder) => {
    if (value) setValue({ ...value, activityStatus: newValue, errors: [] });
  };
  const handleChangeDateChange = (newValue: TemplatableActivityDateRange) => {
    if (value) setValue({ ...value, activityDateRange: newValue, errors: [] });
  };

  const handleSubjectChange = (newValue: string | TemplatePlaceholder) => {
    if (value) setValue({ ...value, subject: newValue, errors: [] });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: "column",
        gap: 3
      }}>
      <EngagementForm
        onActivityChange={(newValue) => handleChangeActivity(newValue)}
        activityValue={value?.activity ?? []}
        onActivityStatusChange={(newValue) => handleChangeActivityStatus(newValue)}
        activityStatus={value?.activityStatus ?? []}
        onActivityDateChange={handleChangeDateChange}
        activityDateValue={value?.activityDateRange ?? defaultFilterValue.activityDateRange}
        setIsFilterInvalid={setIsFilterInvalid}
        isAdvancedSearch
        subject={value?.subject ?? ''}
        onSubjectChange={(value) => handleSubjectChange(value)}
      />
    </Box>
  );
};

export const engagementHistoryWidget: BaseWidget = {
  type: 'engagementHistory',
  hideOperator: true,
  operatorInlineLabel: 'has',
  factory: EngagementHistoryWidgetFactory,
};
